import { render } from "./BookPage.vue?vue&type=template&id=1f02e617&scoped=true"
import script from "./BookPage.vue?vue&type=script&lang=js"
export * from "./BookPage.vue?vue&type=script&lang=js"

import "./BookPage.vue?vue&type=style&index=0&id=1f02e617&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f02e617"]])

export default __exports__